import MainPage from './pages/MainPage';

/** Wurzel des Programm-Frontends (Dateiname App.tsx ist Pflicht fuer die Auto-Discovery). */
export default function App() {
  return <MainPage />;
}
